import MuiTypography, { type TypographyProps } from "@mui/material/Typography";

export type { TypographyProps };

export function Typography(props: TypographyProps) {
  return <MuiTypography {...props} />;
}
